import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Menu, MenuItem } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Modal } from "antd";

import Links from "./components/Links";
import { FarmPoints } from "components/Forms";

// import AddFarmLinks from "features/accountCreation/components/AddFarmLinks";

export default function Ajouter() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showFerme, setShowFerme] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="ajouter-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{
          color: "#fff",
          borderRight: 1,
          borderColor: "#FFFFFF4D",
          height: { lg: "68px" },
          px: 3,
        }}
        startIcon={<AddCircleIcon />}
      >
        AJOUTER
      </Button>

      <Menu
        id="ajouter-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {/* <MenuItem onClick={() => {
            handleClose();
            setTimeout(() => {
              navigate("/");
            }, 100);
          }}
        >
          Accueil
        </MenuItem> */}
      <MenuItem
          onClick={() => {
            handleClose();
            setShowFerme(true);
          }}
        >
        Champs
        </MenuItem>
      {/*   <MenuItem
          onClick={() => {
            handleClose();
            setTimeout(() => {
              navigate("/campaigns/add");
            }, 100);
          }}
        >
          Fiche de plan de campagne
        </MenuItem>
        <MenuItem onClick={() => {
            handleClose();
            setTimeout(() => {
              navigate("/stock-sheet/create-stock");
            }, 100);
          }}
        >
          Fiche de stock
        </MenuItem>
        <MenuItem onClick={() => {
            handleClose();
            setTimeout(() => {
              navigate("/cahier-sheet/cahier-steps");
            }, 100);
          }}
        >
          Journal de caisse
        </MenuItem> */}
      </Menu>
      <FarmPoints
        visible={showFerme}
        onCancel={() => {
          setShowFerme(false);
        }}
        onSuccess={() => {
          setShowFerme(false);
        }}
      />
     {/*  <Modal
        visible={showFerme}
        width={500}
        title={"Ajouter une Champs"}
        centered
        footer={null}
        onCancel={() => setShowFerme(false)}
      >
        <Links onModalClose={() => setShowFerme(false)} />
      </Modal> */}
    </div>
  );
}
